import { Button, Form, Input, InputNumber, Modal } from "antd";
import { useEffect } from "react";
import { toast } from "react-toastify";
import apiService from "../api/apiService";

function InventoryModel({ isOpen, onClose, onSave, hotelId }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!isOpen) return;
    form.resetFields(); // Always reset form on open
  }, [isOpen, form]);

  const handleSave = async (values) => {
    const newInventory = {
      item_name: values.itemName,
      quantity: values.quantity,
      hotel: localStorage.getItem("hotel"),
    };
    try {
      const response = await apiService.post(
        `/inventory/?hotel=${hotelId}`,
        newInventory
      );
      toast.success("Inventory added successfully!");
      /* onSave(response); */
      form.resetFields();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Failed to save the inventory.");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal
      centered
      title="Add Inventory"
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item
          label="Item Name"
          name="itemName"
          rules={[{ required: true, message: "Please enter the item name" }]}
        >
          <Input placeholder="Enter item name" />
        </Form.Item>

        <Form.Item
          label="Quantity"
          name="quantity"
          rules={[{ required: true, message: "Please enter the quantity" }]}
        >
          <InputNumber
            min={0}
            step={1}
            style={{ width: "100%" }}
            placeholder="Enter quantity"
          />
        </Form.Item>

        <div className="form-actions d-flex justify-content-end">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default InventoryModel;
